/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Btn_SendingInputs */

const en_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const es_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const de_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden…`)
};

const zh_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送…`)
};

const ar_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإرسال…`)
};

const fr_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const vi_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang gửi…`)
};

const sw_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inatuma…`)
};

const th_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังส่ง…`)
};

const bs_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slanje…`)
};

const ja_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信…`)
};

const ko_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전송 중…`)
};

const pt_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const it_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio…`)
};

const sv_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skickar…`)
};

const nl_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzenden…`)
};

const da_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sende…`)
};

const nb_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender…`)
};

const fi_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetetään…`)
};

const pl_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam…`)
};

const ru_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка…`)
};

const tr_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor…`)
};

const hi_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजा जा रहा है…`)
};

const id_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim…`)
};

const ms_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghantar…`)
};

const cs_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posílám…`)
};

const el_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποστολή…`)
};

const he_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולח…`)
};

const af_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur tans…`)
};

const hu_contact_btn_sending = /** @type {(inputs: Contact_Btn_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küldés…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Contact_Btn_SendingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_btn_sending = /** @type {((inputs?: Contact_Btn_SendingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Btn_SendingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_btn_sending(inputs)
	if (locale === "de") return de_contact_btn_sending(inputs)
	if (locale === "zh") return zh_contact_btn_sending(inputs)
	if (locale === "ar") return ar_contact_btn_sending(inputs)
	if (locale === "fr") return fr_contact_btn_sending(inputs)
	if (locale === "vi") return vi_contact_btn_sending(inputs)
	if (locale === "sw") return sw_contact_btn_sending(inputs)
	if (locale === "th") return th_contact_btn_sending(inputs)
	if (locale === "bs") return bs_contact_btn_sending(inputs)
	if (locale === "ja") return ja_contact_btn_sending(inputs)
	if (locale === "ko") return ko_contact_btn_sending(inputs)
	if (locale === "pt") return pt_contact_btn_sending(inputs)
	if (locale === "it") return it_contact_btn_sending(inputs)
	if (locale === "sv") return sv_contact_btn_sending(inputs)
	if (locale === "nl") return nl_contact_btn_sending(inputs)
	if (locale === "da") return da_contact_btn_sending(inputs)
	if (locale === "nb") return nb_contact_btn_sending(inputs)
	if (locale === "fi") return fi_contact_btn_sending(inputs)
	if (locale === "pl") return pl_contact_btn_sending(inputs)
	if (locale === "ru") return ru_contact_btn_sending(inputs)
	if (locale === "tr") return tr_contact_btn_sending(inputs)
	if (locale === "hi") return hi_contact_btn_sending(inputs)
	if (locale === "id") return id_contact_btn_sending(inputs)
	if (locale === "ms") return ms_contact_btn_sending(inputs)
	if (locale === "cs") return cs_contact_btn_sending(inputs)
	if (locale === "el") return el_contact_btn_sending(inputs)
	if (locale === "he") return he_contact_btn_sending(inputs)
	if (locale === "af") return af_contact_btn_sending(inputs)
	if (locale === "hu") return hu_contact_btn_sending(inputs)
	return en_contact_btn_sending(inputs)
});